import { Modal, Skeleton } from "antd";
import { useState } from "react";
import { Info } from "react-feather";
import { useTranslation } from "react-i18next";

type TBanner = {
  name: string;
  customer_name: string;
  thumbnail_url: string;
};

const BannerAlbum = ({
  data,
  isLoading,
}: {
  data: TBanner;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState<string | null>(null);

  if (isLoading)
    return (
      <div className="w-full overflow-hidden">
        <Skeleton active />
      </div>
    );

  return (
    <div className="relative w-full flex">
      <img
        src={data.thumbnail_url}
        className="absolute top-0 left-0 w-full h-full object-cover"
        alt="photo-detail"
      />
      <button className="flex items-center gap-2 p-2 !cursor-pointer hover:bg-gray-500 bg-gray-500/50 rounded-full absolute top-0 right-0" onClick={() => {
        setIsInfoModalOpen(t("noteThumbnail"));
      }}>
        <Info className="w-5 h-5 bg-transparent text-gray-50" />
        <span className="text-gray-50 text-sm font-medium">{t("albumDetail.changeThumbnail")}</span>
      </button>
      <div className="pb-[30%]"></div>
      <div
        className={`absolute inset-0 bottom-0 top-1/2 ${
          !data.thumbnail_url && "bg-gray-400"
        } justify-end p-4 md:px-7 md:py-10 text-white text-lg md:text-3xl flex flex-col md:gap-1`}
      >
        <span className="font-semibold">{data.name}</span>
        <div className="text-gray-50 text-sm md:text-base">
          {t("albumDetail.customer") + " " + data.customer_name}
        </div>
      </div>
      <Modal
        open={!!isInfoModalOpen}
        footer={null}
        onCancel={() => setIsInfoModalOpen(null)}
      >
        <div className="flex flex-col gap-2">
          {isInfoModalOpen}
        </div>
      </Modal>
    </div>
  );
};

export default BannerAlbum;
